<h2 mat-dialog-title>
  {{ 'addBoxConfirmationDialog.title' | translate }}
</h2>
<mat-dialog-content>
  @if (box.manager) {
    <div class="manager">
      <dbx-image [fileType]="ApplicationFileType.PartnerLogo" [height]="100" [width]="100"></dbx-image>
      <span>{{ box.manager.name }}</span>
    </div>
  }
  <div class="text">
    <span [innerHTML]="'addBoxConfirmationDialog.description' | translate: { name: box.name }"></span>
    <span [innerHTML]="'addBoxConfirmationDialog.contactSupport' | translate"></span>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()" [disabled]="saving()">{{ 'common.cancel' | translate }}</button>
  <button mat-flat-button cdkFocusInitial (click)="register()" [disabled]="saving()">
    <span class="loading-button-container">
      <span [style.visibility]="saving() ? 'hidden' : 'visible'">
        {{ 'addBoxConfirmationDialog.register' | translate }}
      </span>
      @if (saving()) {
        <mat-spinner diameter="20" />
      }
    </span>
  </button>
</mat-dialog-actions>
